import { Component } from 'react';
import { withRouter } from 'react-router-dom';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {

    const { location } = this.props;
    const { pathname } = this.props;

    if (pathname !== prevProps.location.pathname) {
      document.querySelector('#rootEscritorio').scrollIntoView({
        block: 'start',
        behavior: 'auto'
      });
    }
  }

  render() {

    const { location } = this.props;
    const { children } = this.props;

    return children;
  }
}

export default withRouter(ScrollToTop);
